'use client'
import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'

type Context = {
  title?: string
  setTitle: (value?: string) => void
}

const initialContext: Context = {
  title: undefined,
  setTitle: () => undefined,
}

const context = createContext(initialContext)

export const PageLayoutProvider: FC<PropsWithChildren> = ({ children }) => {
  const [title, setTitle] = useState<string>()

  return <context.Provider value={{ title, setTitle }}>{children}</context.Provider>
}

export const usePageLayoutContext = () => useContext(context)

export const useSetPageLayoutTitle = (title: string) => {
  const { setTitle } = usePageLayoutContext()

  useEffect(() => {
    setTitle(title)

    return () => setTitle(undefined)
  }, [title])
}
